import { render, staticRenderFns } from "./PlanoPluriAnual.vue?vue&type=template&id=621441b8&"
import script from "./PlanoPluriAnual.vue?vue&type=script&lang=js&"
export * from "./PlanoPluriAnual.vue?vue&type=script&lang=js&"
import style0 from "./PlanoPluriAnual.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports